import React from "react"
import PropTypes from "prop-types"

import Button from "../components/button"
import headerImage from "../images/header.png"
import MockupContent from "./image"
import mockupFrame from "../images/landing.png"

const Header = ({ siteTitle }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      padding: "4rem 1rem",
    }}
  >
    <div
      style={{
        backgroundImage: `url(${headerImage})`,
        position: "absolute",
        top: 0,
        zIndex: -5,
        height: "100vh",
        width: "100vw",
        opacity: 0.5,
      }}
    />
    <h1 style={{ textAlign: "center" }}>BuddyCoin </h1>
    <p style={{ textAlign: "center", maxWidth: 440 }}>
    View crypto prices and charts including Bitcoin, Ethereum, XRP and more.
    </p>
    <Button>Download now</Button>
    <div style={{ margin: 60, width: `300px`, position: "relative" }}>
      <img style={{borderRadius: '20px'}} src={mockupFrame}/>
    </div>
  </div>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
